import apiClient from './client';
import type { User } from '../types/user';

export interface AuthConfig {
  oidc_configured: boolean;
  dev_enabled: boolean;
  issuer: string;
}

// 开发模式登录(会话经 HttpOnly cookie 下发)
export function devLogin(username: string) {
  return apiClient.get<{ user: User; dev: boolean }>(`/auth/login?username=${encodeURIComponent(username)}`);
}

export function getAuthConfig() {
  return apiClient.get<AuthConfig>('/auth/config');
}
